export const classes = {
  wrapper: 'pb-4 place-between',
  content: 'flex items-center',
  title: 'mr-1 text-[17px] font-bold text-taupe-3 dark:text-mauve-1',
  activeBadge: 'mr-4',
  inactiveBadge: 'mr-3',
  iconButton:
    'transition-all cursor-pointer text-taupe-2 hover:text-taupe-3 ml-3 dark:text-mauve-2 dark:hover:text-mauve-1',
  activeFilters:
    'active-filters text-taupe-3 hover:text-taupe-3 dark:text-mauve-1',
  controls: 'place-end',
  addButton: 'normal-case font-semibold',
};
